
export const CONTRACT = "landcoin.testnet"

export const CONTRACT_CHANGE_METHODS = ["add_property", "search_property", "add_dispute"]

export const CONTRACT_VIEW_METHODS = []